import { AlertTriangle, AlertOctagon, Hourglass, ShieldAlert } from "lucide-react";
import { NOTIF_TYPES, NOTIF_LABELS } from "../../utils/notificationEngine";
import { formatDateTime } from "../../utils/progressUtils";
import { useNavigate } from "react-router-dom";

const STYLE = {
  TERLAMBAT: {
    icon: AlertOctagon,
    ring: "bg-red-100 text-red-700",
    border: "border-l-4 border-l-red-500",
    chip: "bg-red-50 text-red-700 border-red-200",
  },
  ESKALASI_AUDIT: {
    icon: ShieldAlert,
    ring: "bg-amber-100 text-amber-700",
    border: "border-l-4 border-l-amber-500",
    chip: "bg-amber-50 text-amber-700 border-amber-200",
  },
  STAGNASI: {
    icon: Hourglass,
    ring: "bg-slate-100 text-slate-700",
    border: "border-l-4 border-l-slate-400",
    chip: "bg-slate-50 text-slate-700 border-slate-200",
  },
  PERINGATAN: {
    icon: AlertTriangle,
    ring: "bg-amber-50 text-amber-600",
    border: "border-l-4 border-l-amber-300",
    chip: "bg-amber-50 text-amber-700 border-amber-200",
  },
};

export default function NotificationItem({ notif, onMarkRead, compact = false }) {
  const s = STYLE[notif.type] || STYLE.PERINGATAN;
  const Icon = s.icon;
  const navigate = useNavigate();

  const handleClick = () => {
    onMarkRead?.(notif.id);
    // Jump to the progress page for the target sub (with focus query param)
    if (notif.subId) {
      navigate(`/progress?focus=${encodeURIComponent(notif.subId)}`);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={`notif-item-${notif.id}`}
      data-read={notif.read ? "1" : "0"}
      className={`flex w-full items-start gap-3 rounded-md bg-white ${s.border} ${
        compact ? "p-2.5" : "p-3.5"
      } text-left transition-shadow hover:shadow-sm ${
        notif.read ? "opacity-70" : ""
      }`}
    >
      <div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${s.ring}`}>
        <Icon className="h-4 w-4" strokeWidth={2} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-1.5">
          <span
            className={`inline-flex items-center rounded-full border px-1.5 py-0.5 text-[9.5px] font-semibold uppercase tracking-wider ${s.chip}`}
          >
            {NOTIF_LABELS[notif.type] || notif.type}
          </span>
          <span className="font-mono text-[10.5px] text-slate-500">
            {notif.programKode} · {notif.subId}
          </span>
          {!notif.read ? (
            <span className="ml-1 inline-flex h-1.5 w-1.5 rounded-full bg-[#1e3a5f]" data-testid="unread-dot" />
          ) : null}
        </div>
        <div
          className={`mt-1 leading-snug text-slate-900 ${
            compact ? "text-[12px]" : "text-[13px]"
          } ${notif.read ? "font-normal" : "font-semibold"}`}
        >
          {notif.message}
        </div>
        <div className="mt-1 text-[10.5px] text-slate-500">
          {formatDateTime(notif.createdAt)}
        </div>
      </div>
    </button>
  );
}
